__turbopack_context__.v({
  "Accordion": "Rd951a_Accordion",
  "Accordion--AlwaysOpen": "Rd951a_Accordion--AlwaysOpen",
  "Accordion--Manual": "Rd951a_Accordion--Manual",
  "Accordion__Button": "Rd951a_Accordion__Button",
  "Accordion__Container": "Rd951a_Accordion__Container",
  "Accordion__Content": "Rd951a_Accordion__Content",
  "Accordion__Content--Transition": "Rd951a_Accordion__Content--Transition",
  "Accordion__Icon": "Rd951a_Accordion__Icon",
  "Accordion__Icon--Active": "Rd951a_Accordion__Icon--Active",
  "Accordion__Image": "Rd951a_Accordion__Image",
  "Accordion__ImageWrapper": "Rd951a_Accordion__ImageWrapper",
  "Accordion__Images": "Rd951a_Accordion__Images",
  "Accordion__RichText": "Rd951a_Accordion__RichText",
  "Accordion__Text": "Rd951a_Accordion__Text",
  "Accordion__Title": "Rd951a_Accordion__Title",
  "Accordion__Wrapper": "Rd951a_Accordion__Wrapper",
});
